import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import SectionErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./theme/ThemeProvider";
import { registerServiceWorker, installNotificationClickBuffer } from "./utils/webPush";
import { installStandaloneViewportHeal } from "./utils/standaloneViewport";
import "./index.css";

// Push-уведомления и открытие диалога по нажатию на них (public/sw.js).
registerServiceWorker();
// Адрес диалога из нажатого уведомления ловится до отрисовки панели: иначе
// приложение, запущенное нажатием, открывалось без диалога.
installNotificationClickBuffer();
// Веб-приложение на iPhone: вернуть странице полную высоту после клавиатуры.
installStandaloneViewportHeal();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        {/* Последняя линия: что бы ни упало, вместо чёрного экрана — карточка
            с кнопкой «Обновить страницу». */}
        <SectionErrorBoundary fullScreen>
          <App />
        </SectionErrorBoundary>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
